import ChooseYourCountry from './ChooseYourCountry';
import compose from 'recompose/compose';
import withCountry from '../../hocs/withCountry';
import withCountries from '../../hocs/withCountries';

const enhance = compose(
  withCountry,
  withCountries
);

export default enhance(ChooseYourCountry);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ChooseYourCountry/index.js